import { AfterViewInit, Component, Inject, Input } from "@angular/core";
import { ICommonFilterActionCreator } from "../../redux/actions.interface";
import { GenericActions } from "../../redux/generic-actions";
import { ImmutableRedux } from "../../redux/immutable-redux.service";
import { IGenericValueState } from "../../redux/state.interface";
import { staticFilterReducerFactory } from "./reducer";
import { STATIC_FILTER_STATE_PROP } from "./state-props";

@Component({
    selector: "common-static-filter",
    templateUrl: "./common-static-filter.component.html",
})
export class CommonStaticFilterComponent implements AfterViewInit {
    @Input() public listActions: ICommonFilterActionCreator<any>;
    @Input() public fieldValue: any;
    @Input() public fieldToFilter: string;
    @Input() public isDisplayed = false;

    public initialState: IGenericValueState<any> = { value: undefined };

    constructor(
        private ngRedux: ImmutableRedux<any>,
        @Inject(STATIC_FILTER_STATE_PROP) public rootProp,
    ) { }

    public ngAfterViewInit() {
        this.ngRedux.registerComponent(staticFilterReducerFactory, this.rootProp, this.stateProp, this.initialState);
        this.initialize();
    }

    public get stateProp() {
        return `${this.listActions.stateProp}::${this.fieldToFilter}`;
    }

    public initialize() {
        this.ngRedux.dispatchFactory(GenericActions.VALUE_ADDED, this.rootProp, this.stateProp, this.fieldValue);
        const value = this.ngRedux.getState(this.rootProp, this.stateProp).value;
        this.listActions.isInitialized$.next(true);
        this.listActions.filter(this.fieldToFilter, value);
    }
}
